import { Switch, Route } from 'quartz-routing/react-router';
import ErrorBoundary from './components/Utilities/ErrorBoundary';
import FullPageError from './components/Utilities/FullPageError';
// @ts-expect-error untyped module
import NotificationList from 'ReduxMessenger/components/NotificationList';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import configureStore from './utils/configureStore';
import { Provider } from 'react-redux';
import ApplicationContainer from './containers/ApplicationContainer';
import PreviewContainer from './containers/PreviewContainer';
import { createEmbeddedIframeableContainer } from 'payments-checkout-lib/containers/IframeableContainer';
import { getAllowedParentOrigins } from './utils/urls';
import { getBrowserLocale } from './utils/locale';
import Raven from 'raven-js';
import { checkoutRavenDataCallback } from './utils/raven';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
Raven.setDataCallback(checkoutRavenDataCallback);
const IframeableContainer = createEmbeddedIframeableContainer({
  allowedOrigins: getAllowedParentOrigins()
});

// Overrides es-US/es-419 since they're not supported by our i18n setup.
// Full context here: https://hubspot.slack.com/archives/C6PL2HX0C/p1699986304019579
export const getLocaleInfo = () => {
  let locale = getBrowserLocale();
  if (locale === 'es-US' || locale === 'es-419') {
    locale = 'es-MX';
  }
  return {
    locale,
    langEnabled: true
  };
};
export const prepareApp = () => ({
  props: {
    store: configureStore(),
    client: new DataFetchingClient({
      assumeImmutableResults: true
    })
  }
});
export function AppComponent({
  store,
  client
}) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: client,
    children: /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsxs(ErrorBoundary, {
        boundaryName: "payments-ui",
        ErrorComponent: FullPageError,
        showRefreshAlert: false,
        children: [/*#__PURE__*/_jsxs(Switch, {
          children: [/*#__PURE__*/_jsx(Route, {
            path: "/iframe/preview",
            children: /*#__PURE__*/_jsx(IframeableContainer, {
              children: /*#__PURE__*/_jsx(PreviewContainer, {
                children: /*#__PURE__*/_jsx(ApplicationContainer, {})
              })
            })
          }), /*#__PURE__*/_jsx(Route, {
            path: "/iframe",
            children: /*#__PURE__*/_jsx(IframeableContainer, {
              children: /*#__PURE__*/_jsx(ApplicationContainer, {})
            })
          }), /*#__PURE__*/_jsx(Route, {
            path: "/",
            component: ApplicationContainer
          })]
        }), /*#__PURE__*/_jsx(NotificationList, {})]
      })
    })
  });
}